import React, { useState } from "react";
import { Modal, Button, Form, Row, Col, Card } from "react-bootstrap";
import { useDropzone } from "react-dropzone";
import { publishImage } from "../../helpers/imageupload";
import { getAsset } from "../../helpers/helper";
import { SuccessNotify, FailedNotify } from "../../constants/tostify";
import { ClearIcon } from "@mui/x-date-pickers";
import { images } from "../../constants";
import url from "../../config/axios";
import { useSelector } from "react-redux";  
const AboutServiceModal = ({ show, handleClose, handleSave,id,shopData,Dataloaderfun }) => {
const { name } = useSelector((state) => state.user);
  const [userdata, setUserData] = useState({
    userid: name._id,
      about: "",
  });

  const PostUserdata = () => {
    url
      .put(
        `service/id/?id=${id}`,
        userdata
      )
      .then((res) => {
        if (res.data.success) {
          Dataloaderfun();
          handleClose();
          SuccessNotify(" Added Successfully");
        }
      })
      .catch(() => {
        FailedNotify("Failed to Add  Try Again");
        handleClose();
      });
  };


  const handleServiceChange = (e) => {
  const { name, value } = e.target;

  setUserData((prev) => ({
    ...prev,
    [name]: value,
  }));
};


  return (
    <Modal show={show === 3} onHide={handleClose} centered size="lg">
      <Modal.Header
        className="text-white pt-1 pb-1 "
        style={{ backgroundColor: "#0353A4" }}
        closeButton
      >
        <Modal.Title>About</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          {/* Service Name */}

          {/* Project Description */}
          <Form.Group className="mb-3">
            <Form.Label>Description</Form.Label>
            <Form.Control
              as="textarea"
              rows={8}
              placeholder="Describe your role and responsibilities in this project"
              name="about"
              defaultValue={shopData}
              onChange={(e) => handleServiceChange(e)}
            />
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <button
          className="pt-1 pb-1 ps-3 pe-3 font_11 rounded"
          onClick={handleClose}
          style={{
            backgroundColor: "white",
            border: "1px solid red",
            color: "red",
          }}
        >
          Cancel
        </button>
        <button
          className="pt-1 pb-1 ps-3 pe-3  font_11 rounded"
          onClick={PostUserdata}
          style={{
            backgroundColor: "#0353A4",
            border: "1px solid #0353A4",
            color: "white",
          }}
        >
          Save
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default AboutServiceModal;
